<div>
  <section style="overflow-y: scroll;height: 40%;width: 100%;">
    <div class="wrapper">

        <button type="button" class="add-boutton fa fa-search-plus" style="left: 70%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25%;  font-weight: normal;" name="Addfont" (click)="ZoomIn()"></button>
        <button type="button" class="add-boutton fa fa fa-search-minus" style="left: 74%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25% ;font-weight: normal;" name="Munesfont" (click)="ZoomOut()"></button>
        <button type="button" class="add-boutton" style="left: 83%;" name="Add"[disabled]="disablepharnacy" (click)="OpenDialog()">Add</button>
    </div>

<BR>
<BR>

  <table style="left: 50px;width: 90%;">

    <tr *ngFor="let item of decisionList; let i = index" style="font-size: {{wk_fontsize}}; text-align: left;">
      <label >       </label>
      <td>
          <div style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <label style="font-weight: bold;">{{item.decdate}} {{item.username}}   </label>    <label>({{declocationtext[i]}})</label>
          </div>
          <div>
            <button class="fa fa-pencil" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: green;" matTooltip="Edit" name="Add" (click)="EditDecision(item)"></button>
            <button class="fa fa-trash" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: red;" matTooltip="Delete" name="Delete" (click)="MessegeDelete(item)"></button>
          </div>
        </div>
        <!-- <textarea rows = "15" cols = "103" name = "prognosis" class="appointment-form-field" style="min-height: 150px; height: 5vh; resize: vertical; border-style: none;font-size: {{wk_fontsize}}" readonly>{{item.decnotes}}</textarea><br> -->

        <!-- <label><pre>{{item.decnotes}}</pre></label> -->
        <angular-editor
        [(ngModel)]="item.decnotes"
        [config]="editorConfigNoToolbar" style="border: none !important; box-shadow: none !important;"
    >

      </angular-editor>
        <br>
        <br>
      </td>
    </tr>
  </table>
</section>




